module.exports = __webpack_public_path__ + "img/logo-anct.4d4fc77e.svg";